import { grey } from "@mui/material/colors";

const styles = {
  container: {
    alignItems: "center",
    display: "flex",
    background: "#f7f7f5",
    borderRadius: 8,
    ml: 1,
    px: 1,
    py: 1,
    width: "max-content",
  },
  inactive: {
    color: grey[600],
    textTransform: "none",
    borderRadius: 4,
    fontSize: 13,
  },
  button: {
    px: { xs: 1, md: 2 },
    fontSize: { xs: 11, md: 13 },
    "&:hover": {
      backgroundColor: grey[100],
    },
  },
  active: {
    borderRadius: 4,
    backgroundColor: "white",
    color: "black",
    textTransform: "none",
  },
  yearlyText: {
    color: "purple.main",
    fontSize: { xs: 10, md: 12 },
    ml: 1,
    fontWeight: 600,
  },
};

export default styles;
